<div class="info-panel">
  <div [ngClass]="'info-panel__panel info-panel__panel--' + company | lowercase">
    <div class="info-panel__header">Exam preparation</div>
    <lx-price-lists-portal-more-info-list
      *ngFor="let info of moreInfoData | keyvalue"
      [title]="info.key"
      [moreInfoItems]="info.value"
    ></lx-price-lists-portal-more-info-list>
    <lx-price-lists-portal-table-header title="Exam prep courses" [currency]="currency"></lx-price-lists-portal-table-header>
    <lx-price-lists-portal-price-and-note-table
      [company]="company"
      [dataSource]="dataSource"
      [columnLabels]="columnLabels"
    ></lx-price-lists-portal-price-and-note-table>
  </div>
</div>
